import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { JobTypeServiceCreateResponseJson } from '@vmspdb/definitions';
import * as JobTypeActions from './job-types.actions';

export const jobTypesFeatureKey = 'jobTypes';

export interface JobTypeState extends EntityState<JobTypeServiceCreateResponseJson> {
  error?: any;
}

export const adapter: EntityAdapter<JobTypeServiceCreateResponseJson> =
  createEntityAdapter<JobTypeServiceCreateResponseJson>({
    selectId: (model) => model.uuid || '',
  });

export const initialState: JobTypeState = adapter.getInitialState({
  error: undefined,
});

export const reducer = createReducer(
  initialState,
  on(JobTypeActions.deleteJobType, (state, { item }): JobTypeState => {
    const uuid = item.uuid;
    return uuid ? adapter.removeOne(uuid, state) : state;
  }),
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

export const jobTypeSelectors = adapter.getSelectors();
